import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from "../../../../Atoms";
var TableHeadCell = function (_a) {
    var column = _a.column, numChecked = _a.numChecked, rowsLength = _a.rowsLength, count = _a.count, toggleAll = _a.toggleAll;
    if (column.title) {
        return _jsx("span", { children: column.title });
    }
    return (_jsx(Checkbox, { color: "primary", "data-testid": "head-checkbox-toggle-all", indeterminate: numChecked > 0 && numChecked < rowsLength, checked: numChecked === rowsLength && count > 0, onChange: toggleAll, inputProps: {
            "aria-label": "select all",
        } }));
};
export default TableHeadCell;
